
import React from 'react';
import { connect } from 'react-redux';
import dataFormater from '../../../dataFormater'
import buttonDataFormater from '../../../buttonDataFormater'
import Navbar from '../../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../../_components/common/SideNavBar'
import AnalysisNavBar from '../../../../../../_components/common/AnalysisNavBar'
import DynamicGradientTables from '../../../../../../_components/common/DynamicGradientTables'
import CircularButtonGroup from '../../../../../../_components/common/CircularButtonGroup'
import RoutableSelects from '../../../../../../_components/common/RoutableSelects'
import { buttonGroupData, buttonGroupDataParameters } from '../SwotButtonGroupData'
import { swot_category_data_0, swot_category_data_1, swot_para_category_data_1 } from '../SwotCatagoryData'
import { AnalyzeAction } from '../../../../../../_actions/Analyze/analyze.action'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, analyseActions, saveTeamDetailsAction } from '../../../../../../_actions';


import swotIcon from '../../../../../../images/swotIcon.png'

import strengthDetailTitle from '../../../../../../images/strengthDetailTitle.png';
import weaknessDetailTitle from '../../../../../../images/weaknessDetailTitle.png';
import opportunityDetailTitle from '../../../../../../images/opportunityDetailTitle.png';
import threatDetailTitle from '../../../../../../images/threatDetailTitle.png';

import OverLayLoader from '../../../overLayLoader';


const imageUrls = {
    strengthDetailTitle,
    weaknessDetailTitle,
    opportunityDetailTitle,
    threatDetailTitle
}


class SwotParameters extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            navData: [],
            swot_category_data_0: [],
            filterData: null,
            buttonGroupData: [{
                img: swotIcon,
                link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                name: "All",
                id: 0,
                tooltip_id:0
            }],
            buttonGroupDataParameters: [{
                img: swotIcon,
                link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                name: "All",
                id: 0,
                tooltip_id:0
            }],
            class_name: {
                main_container: 'd-flex flex-row flex-wrap align-items-start col-12',
                container: {
                    container: "d-flex flex-column col-12 w-100 px-2 py-1",
                    style: {
                        margin: 1,
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 100,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row align-items-center justify-content-start text-white ',
                    header_container_non_routable_title: 'font-class-compatibility-title font-weight-bold py-1',
                    header_container_non_routable_optional: 'font-class-compatibility-optional py-1 px-3',
                },
                child_container: {
                    child_container: "d-flex flex-row col-12 w-100 px-0 justify-content-center",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex col-sm-4 col-md-4 col-lg-4 px-0 text-dark text-center',
                    child_content_container_header: 'font-weight-bold font-class-compatibility-title mb-2',
                    child_content_container_desc: 'swotContent mb-3',
                    child_content_container_footer: 'font-weight-bold',
                }
            }
        }
    }

    componentDidMount() {
        var { id } = this.props.match.params
        if (this.props.saveModulePermissionsResponse !== '') {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'SWOT') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        //filter data
        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        //Analyze Data
        if(this.props.AnalyzeDataResonse !== '') {
            this.setState({
                swot_category_data_0: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),
                buttonGroupData: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),'swot_orientation')),
                buttonGroupDataParameters: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),'swot_each'))
            },() => {
            })
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})


    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
                })
            }
        }
        if(prevProp.AnalyzeDataResonse != this.props.AnalyzeDataResonse) {
            if(this.props.AnalyzeDataResonse !== '') {
                this.setState({
                    buttonGroupData: [{
                        img: swotIcon,
                        link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                        name: "All",
                        id: 0,
                        tooltip_id:0
                    }],
                    buttonGroupDataParameters: [{
                        img: swotIcon,
                        link: `/organisation/${this.props.match.params.id}/user/swot/0`,
                        name: "All",
                        id: 0,
                        tooltip_id:0
                    }]
                },() => {
                    this.setState({
                        swot_category_data_0: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),
                        buttonGroupData: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_each_orientation"),'swot_orientation')),
                        buttonGroupDataParameters: this.state.buttonGroupData.concat(buttonDataFormater(this.props,dataFormater(this.props,this.props.AnalyzeDataResonse.data,"swot_all"),'swot_each'))
                    },() => {
                    })
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    render() {
        const { data, navData, } = this.state;

        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                        callBack={this.doSomthing.bind(this)}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <OverLayLoader>
                        <div className="analyz-container">
                            <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                            {
                                this.props.singleValidatorResponse ?
                                <p className="m-3 text-center">
                                    Team Members should be more than 2
                                </p>:
                                <React.Fragment>
                                    {
                                        this.props.AnalyzeDataResonse == '' ?
                                        !this.props.getAnalyzeError ?
                                            <p className="text-center">
                                                <i className="fas fa-spinner fa-spin " ></i>
                                                &nbsp;loading
                                            </p> 
                                            :
                                            <p className="text-center my-5">{this.props.getAnalyzeError.message}</p>
                                            :
                                        <div className="swot-para-container-sub ">
                                            <div className="d-flex justify-content-center drop-down-container my-5">
                                                <h6 className="d-flex justify-content-end align-items-center mb-0 px-2 ">Choose Orientation</h6>
                                                <RoutableSelects swotid={this.props.match.params.parameters} buttonGroupData={this.state.buttonGroupData} {...this.props} />
                                            </div>
                                            <div key={this.props.match.params.parameters} className="d-flex flex-wrap align-items-center col-12 gradient-flex" style={{ paddingLeft: 75, paddingRight: 75 }}>
                                                {
                                                    this.state.swot_category_data_0.map((obj, key) => {
                                                        obj.header_background_image = obj.header_text == 'THREATS' ? imageUrls['threatDetailTitle'] : imageUrls[obj.header_text.toLowerCase() + 'DetailTitle']
                                                        if(obj.header_text.toLowerCase() == this.props.match.params.parameters) {
                                                            return <DynamicGradientTables key={key} classNameProps={this.state.class_name} data={[obj]} isMarginEnabled={true} />
                                                        }
                                                    })
                                                }
                                                <CircularButtonGroup buttonGroupData={this.state.buttonGroupDataParameters} swotCatagory={this.props.match.params.parameters} singleButton={false} />
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </div>
                    </OverLayLoader>
                </ div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

   //Analyze
   const { getAnalyzeLoading } = state.getAnalyzeData
   const getAnalyzeError = state.getAnalyzeData.error
   const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;
    const singleValidatorResponse = state.singleValidatorReducer.data;

    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        AnalyzeDataResonse,
        getAnalyzeError,
        getAnalyzeLoading,
        singleValidatorResponse,       
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError

    }
}

export default connect(mapStateToProps)(SwotParameters)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/SWOT/SwotParameters/index.js